import React from 'react';
import PropTypes from 'prop-types';
import StyledTitle from '../../hoc/StyledTitle';

@StyledTitle
class Dd extends React.Component {

  static propTypes = {
    children: PropTypes.any
  }

  render() {
    const { children, ...props } = this.props;
    return (
      <dd name="Dd" {...props}>{children}</dd>
    );
  }

}

export default Dd;
